const FormLayer = () => {
  return {
    email: '',
    isLoading: false,
    message: '',
    messageType: '',
    overlayActive: false,
    overlayCreated: false,
    overlayElement: null,

    // Initialisierung beim Laden der Komponente
    init() {
      // console.log('FormLayer Alpine-Komponente initialisiert');

      // Overlay bei der Initialisierung vorbereiten, aber nicht anzeigen
      this.$nextTick(() => {
        this.prepareOverlay();
      });

      // Event-Listener für ESC-Taste
      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.overlayActive) {
          this.closeOverlay();
        }
      });
    },

    // Email-Validierung mit HTML5-Validierung
    validateEmail() {
      const emailInput = document.getElementById('email');
      if (!emailInput) return false;

      // HTML5-Validierung nutzen
      return emailInput.checkValidity();
    },

    // Overlay vorbereiten
    prepareOverlay() {
      // console.log('Overlay vorbereiten...');

      // Formie-Formular finden (auch wenn es versteckt ist)
      const formieForm = document.querySelector('.formie-form-layer');

      if (formieForm && !this.overlayCreated) {
        // console.log('Formie-Formular gefunden:', formieForm);

        // Overlay-Container erstellen
        const overlayDiv = document.createElement('div');
        overlayDiv.className = 'fui-overlay';

        // Overlay-Content erstellen
        const overlayContent = document.createElement('div');
        overlayContent.className = 'fui-overlay-content';

        // Close-Button erstellen
        const closeButton = document.createElement('button');
        closeButton.className = 'fui-btn fui-overlay-close';
        closeButton.type = 'button';
        closeButton.innerHTML = '×';
        closeButton.setAttribute('aria-label', 'Close');

        // Event-Listener für den Close-Button
        closeButton.addEventListener('click', () => {
          this.closeOverlay();
        });

        // Event-Listener für Klicks auf den Hintergrund
        overlayDiv.addEventListener('click', (e) => {
          if (e.target === overlayDiv) {
            this.closeOverlay();
          }
        });

        // Formular in das Overlay verschieben
        const formClone = formieForm.cloneNode(true);
        formClone.style.display = 'block';

        // Das Original-Formular aus dem DOM entfernen
        formieForm.remove();

        // Alles ins Overlay zusammenfügen
        overlayContent.appendChild(closeButton);
        overlayContent.appendChild(formClone);
        overlayDiv.appendChild(overlayContent);

        // Overlay an Body anhängen, aber noch nicht anzeigen
        document.body.appendChild(overlayDiv);

        // Referenz speichern
        this.overlayElement = overlayDiv;
        this.overlayCreated = true;

        // console.log('Formie Forms neu initialisieren...');
        // eslint-disable-next-line no-undef
        Formie.initForms();

        // console.log('Overlay erstellt und vorbereitet');
      } else {
        // console.log('Formie-Formular nicht gefunden oder Overlay bereits erstellt');
      }
    },

    // Overlay öffnen
    openOverlay() {
      // console.log('Overlay öffnen angefordert');

      if (!this.overlayCreated) {
        // console.log('Overlay noch nicht erstellt, bereite es vor');
        this.prepareOverlay();
      }

      if (this.overlayElement) {
        // console.log('Overlay-Element gefunden, aktiviere es');
        this.overlayElement.classList.add('fui-active');
        document.body.classList.add('fui-overlay-open');
        this.overlayActive = true;

        try {

          const formieEmailField = this.overlayElement.querySelector('input[name="fields[email]"], input[type="email"]');
          if (formieEmailField) {
            formieEmailField.value = this.email;
            // console.log('E-Mail in das Overlay-Formular übertragen');
          } else {
            // console.warn('Kein E-Mail-Feld im Formular gefunden');
          }

          // E-Mail-Anzeige im Overlay nach dem Copy-Text und vor den Checkboxen einfügen
          const copyElement = this.overlayElement.querySelector('.fui-type-html');
          if (copyElement) {
            // Prüfen, ob bereits ein E-Mail-Info-Element existiert
            let emailInfoElement = this.overlayElement.querySelector('.email-info-display');

            if (!emailInfoElement) {
              // Wenn nicht, neues Element erstellen
              emailInfoElement = document.createElement('div');
              emailInfoElement.className = 'email-info-display';

              // Nach dem Copy-Element einfügen
              const parentRow = copyElement.closest('.fui-row');
              if (parentRow && parentRow.nextElementSibling) {
                const nextRow = parentRow.nextElementSibling;
                parentRow.parentNode.insertBefore(emailInfoElement, nextRow);
              }
            }
          }
        } catch (e) {
          // console.error('Fehler beim Übertragen/Anzeigen der E-Mail:', e);
        }
      } else {
        // console.error('Overlay-Element nicht gefunden');
      }
    },

    // Overlay schließen
    closeOverlay() {
      // console.log('Overlay schließen angefordert');

      if (this.overlayElement) {
        this.overlayElement.classList.remove('fui-active');
        document.body.classList.remove('fui-overlay-open');
        this.overlayActive = false;
        // console.log('Overlay geschlossen');
      }
    },

    // Formular absenden und Overlay öffnen
    submitForm() {
      // console.log('Submit-Form aufgerufen');

      // Zurücksetzen der Nachricht
      this.message = '';
      this.messageType = '';

      // Email validieren
      if (!this.validateEmail()) {
        // console.log('E-Mail-Validierung fehlgeschlagen');
        this.message = 'Bitte gib eine gültige E-Mail-Adresse ein.';
        this.messageType = 'error';
        return;
      }

      // console.log('E-Mail-Validierung erfolgreich:', this.email);

      // Loading-Status aktivieren
      this.isLoading = true;

      try {
        // Focus weg von Email Feld
        document.getElementById('email').blur();
        // Overlay öffnen
        this.openOverlay();

        // Loading-Status deaktivieren
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      } catch (error) {
        // console.error('Fehler beim Öffnen des Overlays:', error);
        this.message = 'Es gab ein Problem beim Öffnen des Formulars.';
        this.messageType = 'error';
        this.isLoading = false;
      }
    }
  };
};

export default FormLayer;
